module.exports = __webpack_public_path__ + "static/media/serchBoomer.87c6a45a.png";